import React, { useEffect, useState } from "react";

import { AnalyticsStrings } from "constants/constantStrings.js";

import AgTable from "components/AgTable";
import BadgeLabel from "components/BadgeLabel/index.js";

import HISTORIC_MEMBRANE_TABLE_COLUMNS from "./CIPHistoricMembraneTable.config";

const AnalyticsHistoricMembraneTable = ({ analyticsRawData }) => {
  const [isMembrane_Events, setIsMembraneEvents] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setIsMembraneEvents(analyticsRawData.Membrane_Events.length);
    setTableData(analyticsRawData.Membrane_Events);
  }, [analyticsRawData.Membrane_Events]);

  return (
    <div className="cleaning-required">
      <div className="cleaning-required--header">
        <BadgeLabel badgeDescription={AnalyticsStrings.historicMembrane} />
      </div>
      {isMembrane_Events ? (
        <>
          <AgTable rowData={tableData} columnDefs={HISTORIC_MEMBRANE_TABLE_COLUMNS} />
        </>
      ): (
        <label className="dupont-form-label">{AnalyticsStrings.noHistoricMembrane}</label>
      )}
    </div>
  );
};

export default AnalyticsHistoricMembraneTable;
